<template>
    <auth-layout>
        <header-page title="Edit Password"/>
        <loading-block v-if="loading" />
        <div v-else>
            <div class="form-edit-password" v-if="user.mustChangePassword !== 'Y'">
                <form-clean-password
                    title="Password Sebelumnya"
                    name="old_password"
                    v-model="form.old_password"
                    :error="errors.hasOwnProperty('old_password') ? errors['old_password'][0] : ''"/>
                <form-clean-password
                    title="Password Baru"
                    name="new_password"
                    @input="handlePassword"
                    :error="errors.hasOwnProperty('new_password') ? errors['new_password'][0] : ''"/>
                <form-clean-password
                    title="Konfirmasi Password Baru"
                    name="new_password_confirmation"
                    @input="handlePasswordConfirmation"
                    :error="errors.hasOwnProperty('new_password_confirmation') ? errors['new_password_confirmation'][0] : ''"/>
            </div>
            <div class="form-edit-password" v-else>
                <p>Karena kamu login menggunakan social media, silahkan tambah password untuk akun kamu.</p>
                <form-clean-password
                    title="Password Baru"
                    name="new_password"
                    v-model="form.new_password"
                    :error="errors.hasOwnProperty('new_password') ? errors['new_password'][0] : ''"/>
                <form-clean-password
                    title="Konfirmasi Password Baru"
                    name="new_password_confirmation"
                    v-model="form.new_password_confirmation"
                    :error="errors.hasOwnProperty('new_password_confirmation') ? errors['new_password_confirmation'][0] : ''"/>
            </div>
            <div class="recaptcha-wrap" v-bind:class="errors.hasOwnProperty('recaptcha') ? 'error' : ''">
                <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                <span>Wajib diisi</span>
            </div>
            <div class="button-wrap">
                <button class="btn btn-primary main-button pill-button bg-orange" @click="handleSubmit">Simpan</button>
            </div>
        </div>
    </auth-layout>
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            errors: [],
            form: {
                old_password: '',
                new_password: '',
                new_password_confirmation: '',
                recaptcha: ''
            },
            user: {},
            loading: true
        }
    },
    mounted() {
        this.getUser()
    },
    methods: {
        async getUser () {
            const token = this.$cookies.get('token');
            await axios.get('/api/user', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.user = response.data
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        handleSubmit() {
            const token = this.$cookies.get('token');
            this.loading = true;
            this.errors = [];
            axios.post('/api/user/change-password', this.form, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                    this.$router.push({name: 'profile'});
                })
                .catch((error) => {
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        });
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                        }
                    }
                    this.loading = false;
                    // Reset recaptcha for load new
                    this.$refs.recaptcha.reset();
                });
        },
        handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        handlePassword(value) {
            if(value.length < 8) {
                this.errors = {
                    ...this.errors,
                    new_password: ["Password minimal 8 karakter"]
                };
            } else {
                this.errors = [];
                this.form.new_password = value
            }
        },
        handlePasswordConfirmation(value) {
            this.form.new_password_confirmation = value;
            if(value.length >= 8) {
                if(this.form.new_password !== value) {
                    this.errors = {
                        ...this.errors,
                        new_password_confirmation: ["Password konfirmasi tidak sama"]
                    };
                } else {
                    this.errors = [];
                    this.form.new_password_confirmation = value
                }
            } else {
                this.errors = {
                    ...this.errors,
                    new_password_confirmation: ["Password minimal 8 karakter"]
                };
            }
        }
    }
}
</script>
<style scoped>
.form-edit-password {
    padding: 0 5%;
}
</style>
